// When a wenskaart is picked from the modal, sync the dropdown and close the modal.
document.addEventListener("DOMContentLoaded", () => {
  // Move the modal to <body> so position:fixed isn't trapped by an ancestor
  // with `transform` (the product__info-wrapper has animate--slide-in which
  // creates a containing block and breaks fullscreen overlay positioning).
  const modal = document.getElementById("wenskaarten");
  if (modal && modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  const buttons = document.querySelectorAll(".wenskaart-button");
  if (buttons.length === 0) return;

  const updateSelect = (cardId) => {
    const select = document.getElementById("additional-products");
    if (!select) return;
    select.value = cardId;
    select.dispatchEvent(new Event("change"));
  };

  const closeModal = () => {
    const dialog = document.getElementById("wenskaarten");
    if (!dialog) return;
    dialog.removeAttribute("open");
    document.body.classList.remove("overflow-hidden");
  };

  buttons.forEach((button) => {
    button.addEventListener("click", () => {
      updateSelect(button.getAttribute("data-card-id"));
      closeModal();
    });
  });
});
